<template>
    <div class="form">
        <!--步骤条-->
        <steps :active="active" :isUpload="isUpload" :emsNeeded="matterInfo.emsNeeded"></steps>
        <!--第一页（申报信息）-->
        <div v-show="active === 0">
            <!--基本信息-->
            <p class="title">申请人信息</p>
            <van-cell-group class="approve-company-box">
                <van-field required readonly label="申请经办人" :value="declareInfo.body.jbrxm"
                           input-align="right"/>
                <van-field required label="手机号码" v-model="declareInfo.body.jbrsjhm" input-align="right"/>
                <van-field required readonly clickable label="证件类型" input-align="right" is-link
                           :value="declareInfo.body.jbrzjlxName"
                           placeholder="请选择"/>
                <van-popup v-model="showUserInfoPickerCardType" position="bottom">
                    <van-picker show-toolbar :columns="userInfoCardTypeOptions" value-key="name"
                                @cancel="showUserInfoPickerCardType = false"
                                @confirm="onConfirmUserInfoCardType"/>
                </van-popup>
                <van-field required label="证件号码" input-align="right"
                           :value="declareInfo.body.jbrzjhm"
                           readonly/>
<!--                <van-field required label="联系地址" input-align="right" type="textarea"-->
<!--                           v-model="declareInfo.body.jbrlxdz"-->
<!--                           placeholder="请输入联系人地址" rows="1" autosize clearable/>-->
                <p class="title" style="background:RGB(242,242,241)">企业信息</p>
                <van-field required label="企业名称" input-align="right" v-model="declareInfo.body.qymc"
                           placeholder="请输入企业名称" clearable/>
                <van-field required readonly clickable label="企业类型" input-align="right" is-link
                           :value="declareInfo.body.qylxName"
                           @click="showCompPickerCardType = true"
                           placeholder="请选择"/>
                <van-popup v-model="showCompPickerCardType" position="bottom">
                    <van-picker show-toolbar :columns="compCardTypeOptions" value-key="name"
                                @cancel="showCompPickerCardType = false"
                                @confirm="onConfirmCompCardType"/>
                </van-popup>
                <van-field required label="统一社会信用代码" input-align="right"
                           v-model="declareInfo.body.shxydm" clearable/>
                <van-field required label="法定代表人" input-align="right"
                           v-model="declareInfo.body.frxm" clearable/>
                <van-field required label="法定代表人身份证" input-align="right"
                           v-model="declareInfo.body.frzjhm" clearable/>
<!--                <van-field required readonly clickable label="法人证件类型" input-align="right" is-link-->
<!--                           :value="declareInfo.body.frzjlxName" @click="showUserCompPickerCardType = true"-->
<!--                           placeholder="请选择"/>-->
<!--                <van-popup v-model="showUserCompPickerCardType" position="bottom">-->
<!--                    <van-picker show-toolbar :columns="userCompCardTypeOptions" value-key="name"-->
<!--                                @cancel="showUserCompPickerCardType = false"-->
<!--                                @confirm="onConfirmUserCompCardType"/>-->
<!--                </van-popup>-->
                <van-field required label="企业电话" input-align="right"
                           v-model="declareInfo.body.qydh" clearable/>
                <van-field label="企业邮箱" input-align="right" required
                           v-model="declareInfo.body.qyyx" clearable/>
                <van-field required label="企业地址" input-align="right"
                           v-model="declareInfo.body.qydz" clearable/>
                <p class="title" style="background:RGB(242,242,241)">联系人信息</p>
                <van-field required label="联系人" input-align="right"
                           v-model="declareInfo.body.lxrxm" clearable/>
                <van-field label="联系人身份证" input-align="right"
                           v-model="declareInfo.body.lxrzjhm"  required clearable/>
                <van-field required label="联系人电话" input-align="right"
                           v-model="declareInfo.body.lxrsjhm" clearable/>
                <van-field label="联系人邮编" input-align="right" required
                           v-model="declareInfo.body.lxryb" clearable/>
                <van-field label="联系人地址" input-align="right" required
                           v-model="declareInfo.body.lxrdz" clearable/>
            </van-cell-group>
            <div class="btn-submit-div btn-submit-back">
                <van-button type="info" size="large" @click="next(1)">下一步</van-button>
            </div>
        </div>
        <!--第二页（附件上传）-->
        <div v-show="active === 1" v-if="isUpload">
            <p class="title">附件上传</p>
            <van-cell-group v-for="(item, index) in matterInfo.manifests" :key="index">
                <upload-image :title="item.itemName" :required="item.requred === 'Y'"
                              :uploadPath="`${path}?guid=${item.guid}&idx=${index}`"
                              :matId='item.guid' ref="imageChildFunction" :informationShowData="informationShowData"
                              @setImageInfo="getImageInfo"
                              @setIsImages="getIsImages"></upload-image>
            </van-cell-group>
            <div class="btn-submit-div-double">
                <van-button class="btn-left" type="info" size="large" @click="up(0)">上一步</van-button>
                <van-button class="btn-right" type="info" size="large" @click="next(2)">下一步</van-button>
            </div>
        </div>
        <!-- 第三页（办理方式）-->
        <div v-show="active === 2">
            <!--邮寄信息-->
            <mailing @setNextUpShow="getNextUpShow" :matterInfo="matterInfo" :declareInfo="declareInfo.taskApply"
                     v-if="matterInfo.emsNeeded === 'Y'"
                     ref="mailingChildFunction"
                     @setMailingData="getMailingData" @getStatus="getStatus"></mailing>
            <div class="btn-submit-div-double" v-if="nextUpShow">
                <van-button class="btn-left" type="info" size="large" @click="up(1)">上一步</van-button>
                <van-button class="btn-right" type="info" size="large" @click="next(3)">下一步</van-button>
            </div>
        </div>
        <!--第四页（提交确认）-->
        <div v-show="active === 3">
            <!--展示信息-->
            <information-show :informationShowData="informationShowData"
                              :showPropList="baseInfoList"
                              @setActive="getActive"></information-show>
            <div class="btn-submit-div-double">
                <van-button class="btn-left" type="info" size="large" :matterInfo='matterInfo'
                            @click="matterInfo.emsNeeded === 'Y'?up(2):up(1)">上一步
                </van-button>
                <van-button class="btn-right" type="info" size="large" @click="submit">提交</van-button>
            </div>
        </div>
    </div>
</template>

<script>
    /**
     * Description: 定制化行政审批法人表单
     * Author: liuxw
     * Date: 2019-10-24
     * Time: 14:17
     */

    import {Button, Toast, CellGroup, Dialog, Cell, Field, Popup, Picker, DatetimePicker} from 'vant'
    import {matterApiMap} from '@/api/matter'
    import Steps from "@/components/declare/Steps"
    import SelectPolice from "@/components/declare/SelectPolice"
    import BasicInformation from "@/components/declare/BasicInformation"
    import UploadImage from "@/components/upload-image/UploadImage"
    import Mailing from "@/components/declare/Mailing"
    import InformationShow from "@/components/custom/InformationShow";
    // import CustomForm from './custom/CustomForm';
    import {taskApiMap} from "@/api/task";
    import {userInfoCardType, userCompCardType} from './dict/index'
    import {phoneRegex, idCardRegex,cardNumRegex,emailRegexlian,emailNumRegex} from '@/utils/regex'
    import {emailRegex} from "../../../../utils/regex";

    export default {
        name: "StandardMatter",
        components: {
            InformationShow,
            Mailing,
            UploadImage,
            Steps,
            SelectPolice,
            BasicInformation,
            // CustomForm,
            [Button.name]: Button,
            [Toast.name]: Toast,
            [CellGroup.name]: CellGroup,
            [Dialog.name]: Dialog,
            [Cell.name]: Cell,
            [Field.name]: Field,
            [Popup.name]: Popup,
            [Picker.name]: Picker,
            [DatetimePicker.name]: DatetimePicker
        },
        data() {
            return {
                flag: '', //办理方式传过来的状态
                active: 0, // 控制步骤条当前位置
                matterInfo: {}, // 存放事项信息
                userInfoCardTypeOptions: userInfoCardType, // 申请经办人证件类型列表
                compCardTypeOptions: [{id: '企业', name: '企业'}], // 企业类型列表
                userCompCardTypeOptions: userCompCardType, // 法人证件类型列表
                showUserInfoPickerCardType: false, // 证件类型选择框展示状态
                showCompPickerCardType: false, // 企业类型选择框展示状态
                showUserCompPickerCardType: false, // 法人证件类型选择框展示状态
                isUpload: false, // 判断是否有附件上传
                userInfo: {}, // 存放个人信息
                baseInfoList: [], // 展示组件展示的基本信息
                path: global.storageUrl + '/storage/upload', // 上传图片的地址
                isImagesList: [], // 存放每组上传图片是否已经上了
                nextUpShow: true, // 控制邮寄信息'上一页'和'下一页'显示与隐藏
                informationShowData: { // 展示信息
                    userInfoName: '', // 姓名（展示信息）
                    userInfoPhone: '', // 经办人手机号
                    userInfoCardTypeName: '身份证',
                    userInfoCardType: 10, // 证件类型
                    userInfoCardNum: '', // 身份证（展示信息）
                    compName: '', // 企业名称（展示信息）
                    compType: '', // 企业类型
                    compTypeName: '', // 企业类型名称（展示信息）
                    compCode: '', // 社会信用代码
                    compRepresentative: '', // 法定代表人
                    userCompCardTypeName: '', // 法人证件类型名称
                    userCompCardType: '', // 法人证件类型
                    userCompCardNum: '', // 法人证件号码
                    userCompName: '', // 法定联系人
                    userCompPhone: '', // 法定联系人电话号码
                    compLinkAddress: '', // 法定联系人地址
                    isUpload: false, // 是否有附件上传状态（展示信息）
                    imageTitleList: [], // 附件标题列表（展示信息）
                    imageList: [], // 附件列表（展示信息）
                    mailingShow: '', // 是否有邮寄信息状态（展示信息）
                    mailingStatus: '', // 邮寄流程（展示信息）：1：办结送件，2：双程，3：上门取件
                    takeData: {}, // 取件信息（展示信息）
                    takePrice: '', // 取件费用（展示信息）
                    receiveData: {}, // 送件信息（展示信息）
                    receivePrice: '', // 送件费用（展示信息）
                    totalPrice: '' // 工本费（展示信息）
                },
                declareInfo: {
                    // 标准事项
                    taskApply: {
                        matNum: '', // 事项编号
                        deptId: global.xzspDept, // 所选公安部门id
                        // linkAddress: '', // 联系地址
                        linkAddress: 'null', // 联系地址
                        linkPhone: '', // 电话号码
                        netProjectType: 'WEI',  // 申报方式(PCP|WIN|WEI|WAP|APP)
                        tskSource: 'SYS', // 申报来源(写死)
                        isMailMertal: '0', // 邮寄方式 101：EMS邮寄线上支付
                        wfId: '', // 工作流id
                        manifests: [], // 存放附件信息
                        accountId: this.$cookie.getUser().acountId, // 注册的电话号码
                        addressGuidQj: '', // 邮寄地址上门Guid
                        addressGuidSh: '', // 邮寄地址送件Guid
                        qjMoney: '', // 取件费用
                        shMoney: '', // 收件费用
                        gbMoney: '', // 工本费
                        emsConfig: '', // 邮寄流程：1：办结送件，2：双程，3：上门取件
                    },
                    // 定制化事项
                    body: {
                        /**事项名称*/
                        sxmc: '',
                        /**事项编码*/
                        sxbm: '',
                        /**事项编号*/
                        sxbh:'',
                        // /**办件编号*/
                        // bjbm: '',
                        /**申请经办人姓名*/
                        jbrxm: '',
                        /**申请经办人手机号码*/
                        jbrsjhm: '',
                        /**经办人证件类型（目前固定只有居民身份证）*/
                        jbrzjlx: 10,
                        /**经办人证件类型名称（目前固定只有居民身份证）*/
                        jbrzjlxName: '居民身份证',
                        /**经办人联系地址*/
                        jbrlxdz:'',
                        /**经办人证件号码*/
                        jbrzjhm: '',
                        /**企业名称*/
                        qymc: '',
                        /**企业类型（目前固定只有企业）*/
                        qylx: '',
                        /**社会信用代码*/
                        shxydm: '',
                        /**法人姓名*/
                        frxm: '',
                        // /**法人证件类型（目前固定只有居民身份证）*/
                        // frzjlx: '',
                        /**法人证件号码*/
                        frzjhm: '',
                        /**企业联系人姓名*/
                        lxrxm: '',
                        /**企业联系人手机号码*/
                        lxrsjhm: '',
                        /**企业电话*/
                        qydh:'',
                        /**企业邮箱*/
                        qyyx:'',
                        /**企业地址*/
                        qydz:'',
                        /**联系人身份证*/
                        lxrzjhm:'',
                        /**联系人邮编*/
                        lxryb:'',
                        /**联系人地址*/
                        lxrdz:''
                    }
                },
                customFormInfo: {
                    username: '',
                    deptId: '',
                    isMail: true
                },
            }
        },
        mounted() {
            this.getMatterInfo()
            this.getUserInfo()
        },
        beforeRouteLeave(to, from, next) { // 对图片预览过程中，直接使用浏览器返回上一页，关闭图片预览
            for (let index in this.$refs.imageChildFunction) {
                this.$refs.imageChildFunction[index].closePreview()
            }
            next()
        },
        methods: {
            /**
             * 选择的办理方式
             * status false:窗口办理 true:邮寄服务
             */
            getStatus(status) {
                this.flag = status
            },
            /**
             * 获取事项信息
             */
            async getMatterInfo() {
                try {
                    const res = await this.$httpUtils.getCommonUtils(`${matterApiMap.getMattersEtDetail}/${this.$route.query.guid}`)
                    this.matterInfo = res.data.data
                    this.declareInfo.taskApply.matNum = this.matterInfo.matNum
                    this.declareInfo.taskApply.emsConfig = this.matterInfo.emsConfig
                    this.informationShowData.mailingShow = this.matterInfo.emsNeeded
                    this.informationShowData.mailingStatus = this.matterInfo.emsConfig
                    this.declareInfo.taskApply.wfId = this.matterInfo.wfId
                    // 事项名称和事项编号赋值 事项编码
                    this.declareInfo.body.sxbm = this.matterInfo.guid
                    this.declareInfo.body.sxmc = this.matterInfo.matName
                    this.declareInfo.body.sxbh = this.matterInfo.matNum
                    if (this.matterInfo.manifests.length) {
                        this.isUpload = true
                        this.informationShowData.isUpload = true
                        this.informationShowData.imageTitleList = this.matterInfo.manifests
                    }
                } catch (error) {
                    console.log(error)
                }
            },

            /**
             * 获取个人信息
             */
            async getUserInfo() {
                if (this.$cookie.loginState()) {
                    this.userInfo = this.$cookie.getUser()
                    let province = this.userInfo.province === null || this.userInfo.province === undefined ? "" : this.userInfo.province
                    let city = this.userInfo.city === null || this.userInfo.city === undefined ? "" : this.userInfo.city
                    let area = this.userInfo.area === null || this.userInfo.area === undefined ? "" : this.userInfo.area
                    let address = this.userInfo.address === null ? "" : this.userInfo.address
                    let fullAddress = province.toString() + city.toString() + area.toString() + address.toString()
                    if (fullAddress === '0') {
                        fullAddress = ''
                    }
                    this.userInfo.fullAddress = fullAddress
                    // this.declareInfo.taskApply.linkAddress = fullAddress
                    this.declareInfo.body.jbrlxdz = fullAddress
                    this.declareInfo.taskApply.linkPhone = this.userInfo.telephone
                    this.declareInfo.body.jbrsjhm = this.userInfo.telephone
                    this.declareInfo.body.jbrxm = this.userInfo.realName
                    this.declareInfo.body.jbrzjhm = this.userInfo.idNum

                }
            },
            /**
             * 选择经办人证件类型
             * @param value
             */
            onConfirmUserInfoCardType(value) {
                this.showUserInfoPickerCardType = false
                this.declareInfo.body.jbrzjlx = value.id
                this.declareInfo.body.jbrzjlxName = value.name
            },
            /**
             * 选择企业类型
             */
            onConfirmCompCardType(value) {
                this.showCompPickerCardType = false
                this.declareInfo.body.qylx = value.id
                this.declareInfo.body.qylxName = value.name

            },
            /**
             * 选择法人证件类型
             */
            onConfirmUserCompCardType(value) {
                this.showUserCompPickerCardType = false
                this.declareInfo.body.frzjlx = value.id
                this.declareInfo.body.frzjlxName = value.name
            },
            /**
             * 检查基本信息
             */
            checkBaseInformation() {
                if (!this.declareInfo.body.jbrxm.trim()) {
                    Toast('请输入申请经办人')
                    return false
                }
                if (!this.declareInfo.body.jbrsjhm.trim()) {
                    Toast('请输入经办人手机号')
                    return false
                }
                if(!phoneRegex(this.declareInfo.body.jbrsjhm)) {
                    Toast('请输入正确的经办人手机号')
                    return false
                }
                if (!this.declareInfo.body.jbrzjlx) {
                    Toast('请选择经办人证件类型')
                    return false
                }
                if (!this.declareInfo.body.jbrzjhm.trim()) {
                    Toast('请输入经办人证件号码')
                    return false
                }
                if(!idCardRegex(this.declareInfo.body.jbrzjhm)) {
                    Toast('请输入正确的经办人证件号码')
                    return false
                }
                // if (!this.declareInfo.body.jbrlxdz.trim()) {
                //     Toast('请输入联系地址')
                //     return false
                // }
                if (!this.declareInfo.body.qymc.trim()) {
                    Toast('请输入企业名称')
                    return false
                }
                if (!this.declareInfo.body.qylx) {
                    Toast('请选择企业类型')
                    return false
                }
                if (!this.declareInfo.body.shxydm.trim()) {
                    Toast('请输入社会信用代码')
                    return false
                }
                // if(!cardNumRegex(this.declareInfo.body.shxydm)) {
                //     Toast('请输入正确的18位社会信用代码')
                //     return false
                // }
                if (!this.declareInfo.body.frxm.trim()) {
                    Toast('请输入法定代表人')
                    return false
                }
                if(!(/^[\u4e00-\u9fa5]{2,4}$/.test(this.declareInfo.body.frxm))){
                    Toast('请输入正确的法定代表人姓名')
                    return false;
                }
                if (!this.declareInfo.body.frzjhm.trim()) {
                    Toast('请输入法定代表人身份证')
                    return false
                }
                if(!idCardRegex(this.declareInfo.body.frzjhm)) {
                    Toast('请输入正确的法定代表人身份证')
                    return false
                }
                if (!this.declareInfo.body.qydh.trim()) {
                    Toast('请输入企业电话')
                    return false
                }
                if (!this.declareInfo.body.qyyx.trim()) {
                    Toast('请输入企业邮箱')
                    return false
                }
                if (!emailRegex(this.declareInfo.body.qyyx)){
                    Toast('请输入正确的企业邮箱')
                    return false
                }
                if (!this.declareInfo.body.qydz.trim()) {
                    Toast('请输入企业地址')
                    return false
                }
                if (!this.declareInfo.body.lxrxm.trim()) {
                    Toast('请输入联系人')
                    return false
                }
                if (!this.declareInfo.body.lxrzjhm.trim()) {
                    Toast('请输入联系人身份证号')
                    return false
                }
                if(!idCardRegex(this.declareInfo.body.lxrzjhm)) {
                    Toast('请输入正确的联系人人证件号码')
                    return false
                }
                if(!(/^[\u4e00-\u9fa5]{1,10}$/.test(this.declareInfo.body.lxrxm))){
                    Toast('请输入正确的联系人姓名')
                    return false;
                }
                if (!this.declareInfo.body.lxrsjhm.trim()) {
                    Toast('请输入联系人电话')
                    return false
                }
                if (!phoneRegex(this.declareInfo.body.lxrsjhm)) {
                    Toast('请输入正确的联系人电话')
                    return false
                }
                if (!this.declareInfo.body.lxryb.trim()) {
                    Toast('请输入联系人邮编')
                    return false
                }
                if (!emailNumRegex(this.declareInfo.body.lxryb)) {
                    Toast('请输入正确的联系人邮编')
                    return false
                }
                if (!this.declareInfo.body.lxrdz.trim()) {
                    Toast('请输入联系人地址')
                    return false
                }
                return true
            },
            /**
             * 下一页
             * @param index 传入每一页下标
             */
            next(index) {
                Toast.clear()
                // this.userInfo.fullAddress = this.declareInfo.body.jbrlxdz
                // this.declareInfo.taskApply.linkAddress = this.declareInfo.body.jbrlxdz
                // 验证基本信息
                if (!this.checkBaseInformation()) {
                    return;
                }
                if (index === 1) { // 申报信息页面验证
                    if (this.isUpload) { // 根据是否有上传附件判断进入'附件上传'或'办理方式'
                        this.active = 1
                    } else if (this.matterInfo.emsNeeded === 'Y') {
                        this.active = 2
                    } else {
                        // 到第三页传值
                        this.sendCustomInfomation()
                        this.active = 3
                    }
                } else if (index === 2) { // 附件上传页面验证
                    this.declareInfo.taskApply.manifests = []
                    this.informationShowData.imageList = []
                    this.isImagesList = []
                    for (let index in this.$refs.imageChildFunction) { // 上传图片赋值
                        this.$refs.imageChildFunction[index].passImageValue()
                    }
                    for (let index in this.isImagesList) { // 判断必上传的图片是否上传
                        if (!this.isImagesList[index]) {
                            Toast('请选择上传附件')
                            return
                        }
                    }
                    if (this.matterInfo.emsNeeded === 'Y') {
                        this.active = 2
                    } else {
                        // 到第三页传值
                        this.sendCustomInfomation()
                        this.active = 3
                    }
                } else if (index === 3) {
                    this.$refs.mailingChildFunction.passMailingValue()
                    if (this.flag === false) { // false:窗口办理 true:邮寄服务
                        this.informationShowData.mailingShow = false
                        this.declareInfo.taskApply.isMailMertal = '0'
                        this.active = 3
                    } else { // 邮寄服务
                        this.informationShowData.mailingShow = this.matterInfo.emsNeeded
                        this.declareInfo.taskApply.isMailMertal = '101' // 办理方式：'0'窗口办理，'101'邮寄

                        if (this.declareInfo.taskApply.emsConfig === '3' && !this.declareInfo.taskApply.addressGuidQj) {
                            Toast('请添加地址')
                            return
                        }
                        if (this.declareInfo.taskApply.emsConfig === '1' && !this.declareInfo.taskApply.addressGuidSh) {
                            Toast('请添加地址')
                            return
                        }
                        if (this.declareInfo.taskApply.emsConfig === '2' && !this.declareInfo.taskApply.addressGuidQj && !this.declareInfo.taskApply.addressGuidSh) {
                            Toast('请至少选择一种邮寄方式')
                            return
                        }

                        if (this.declareInfo.taskApply.addressGuidQj && this.declareInfo.taskApply.addressGuidSh) {//两者都选
                            this.informationShowData.mailingStatus = '2'
                        } else if (this.declareInfo.taskApply.addressGuidQj) { // 二选一
                            // 选择了取件地址
                            this.informationShowData.mailingStatus = '3'
                            this.declareInfo.taskApply.addressGuidSh = ''
                        } else if (this.declareInfo.taskApply.addressGuidSh) {
                            // 选择了收件地址
                            this.informationShowData.mailingStatus = '1'
                            this.declareInfo.taskApply.addressGuidQj = ''
                        }
                    }
                    // 到第三页传值
                    this.sendCustomInfomation()
                    this.active = 3

                }
            },

            /**
             * 上一页
             * @param index 传入每一页下标
             */
            up(index) {
                if (index === 0) {
                    this.active = 0
                } else if (index === 1) {
                    this.active = 1
                } else if (index === 2) {
                    this.active = 2
                }
            },

            /**
             * 传给定制化展示组件基本信息
             */
            sendCustomInfomation() {
                const baseInfoList = [
                    {title: '申请经办人', prop: this.declareInfo.body.jbrxm},
                    {title: '经办人手机号码', prop: this.declareInfo.body.jbrsjhm},
                    {title: '经办人证件类型', prop: this.declareInfo.body.jbrzjlxName},
                    {title: '经办人证件号码', prop: this.declareInfo.body.jbrzjhm},
                    // {title: '经办人联系地址', prop: this.declareInfo.body.jbrlxdz},
                ]
                this.baseInfoList = baseInfoList
            },

            /**
             * 接收上传图片组件传来的image列表
             * @param value image列表
             */
            getImageInfo(value) {
                if (value.length > 0) {
                    for (let index in value) {
                        this.declareInfo.taskApply.manifests.push(value[index])
                        this.informationShowData.imageList.push(value[index])
                    }
                }
            },

            /**
             * 接收是否上传图片的状态
             * @param value 是否上传了图片状态
             */
            getIsImages(value) {
                this.isImagesList.push(value)
            },

            /**
             * 接收邮寄信息组件传来的是否展示邮寄信息的'上一页'和'下一页'的状态
             * @param value 布尔值
             */
            getNextUpShow(value) {
                this.nextUpShow = value
            },

            /**
             * 接收邮寄信息组件
             * @param value 布尔值
             */
            getMailingData(value) {
                this.declareInfo.taskApply.addressGuidQj = value.addressGuidQj
                this.declareInfo.taskApply.addressGuidSh = value.addressGuidSh
                this.declareInfo.taskApply.qjMoney = value.qjMoney
                this.declareInfo.taskApply.shMoney = value.shMoney
                this.declareInfo.taskApply.gbMoney = value.gbMoney
                this.informationShowData.takeData = value.takeData
                this.informationShowData.takePrice = value.qjMoney
                this.informationShowData.receiveData = value.receiveData
                this.informationShowData.receivePrice = value.shMoney
                this.informationShowData.totalPrice = value.gbMoney
            },

            /**
             * 接收事项信息展示组件传来的值，改变active参数
             * @param value 传来的下标，改变active参数
             */
            getActive(value) {
                this.active = value
            },
            /**
             * 提交时，需要把标准化事项和定制化事项的两个数据对象合并
             * @return {Promise<void>}
             */
            async submit() {
                Toast.loading({
                    duration: 0,       // 持续展示 toast
                    forbidClick: true, // 禁用背景点击
                    loadingType: 'spinner',
                    message: '提交中...'
                })
                try {
                    const res = await this.$httpUtils.postGatewayUtils(taskApiMap.xzspCompTsk, this.declareInfo)
                    if (res.data.succ) {
                        Toast.clear()
                        if (this.informationShowData.mailingShow === 'Y') {
                            Dialog.alert({
                                title: '申报成功',
                                message: `您的办件编号为:${res.data.data}`
                            }).then(() => {
                                this.$router.push('/myHandlingList')
                            })

                        } else {
                            Dialog.alert({
                                title: '申报成功，预审通过后，您可以携带相关办件材料至窗口办理',
                                message: `您的办件编号为:${res.data.data}`
                            }).then(() => {
                                this.$router.push('/myHandlingList')
                            })
                        }

                    } else {
                        Toast.fail('申报失败')
                    }
                } catch (error) {
                    console.log(error)
                    Toast.clear()
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    @import "~@assets/css/views/matter/declare/standard-matter/StandardMatter.less";
</style>

<style>
    .approve-company-box .van-field__label {
        width: 2.5rem;
    }
</style>
